var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/auth-login/components/consumers-list.tsx";
import { List as ImmutableList } from 'immutable';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Card, HStack, Text } from 'soapbox/components/ui';
import { useAppSelector } from 'soapbox/hooks';
import ConsumerButton from './consumer-button';

/** Displays OAuth consumers to log in with. */
const ConsumersList = () => {
  const providers = useAppSelector(state => ImmutableList(state.instance.pleroma.get('oauth_consumer_strategies')));

  if (providers.size > 0) {
    return /*#__PURE__*/React.createElement(Card, {
      className: "p-4 sm:rounded-xl bg-gray-50 dark:bg-primary-800",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 19,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Text, {
      size: "xs",
      theme: "muted",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 20,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "oauth_consumers.title",
      defaultMessage: "Other ways to sign in",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 11
      }
    })), /*#__PURE__*/React.createElement(HStack, {
      space: 2,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23,
        columnNumber: 9
      }
    }, providers.map(provider => /*#__PURE__*/React.createElement(ConsumerButton, {
      provider: provider,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 25,
        columnNumber: 13
      }
    }))));
  } else {
    return null;
  }
};

export default ConsumersList;